import type { Dispatch, SetStateAction } from "react";
import { useEffect } from "react";

import type { IFilter } from "@components/molecules/filter";

interface IUseSetFilter {
  filters: IFilter[] | undefined;
  setFilters: Dispatch<SetStateAction<IFilter[]>>;
}

export const useSetFilter = ({ filters, setFilters }: IUseSetFilter) => {
  useEffect(() => {
    const _filters = filters || [];

    setFilters((prevState) => {
      if (!filters) return prevState;
      if (!prevState || prevState?.length === 0) return _filters;
      if (JSON.stringify(_filters) === JSON.stringify(prevState)) {
        return prevState;
      }
      return _filters;
    });
  }, [filters, setFilters]);
};
